let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k2s7n")).then(() => parcelRequire('196zp'));